export class Approver {
    _id: String;
    name: String;

    loadFromServer(r: any) {
        this._id = r._id;
        this.name = r.name;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/Approver.model.ts